// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my-tickets {
  background-color: #F6F6F6;
  padding-block: 24px;
}

.my-tickets__container {
  border-radius: 8px;
  background: #FFFFFF;
}

.my-tickets__title {
  color: #323232;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  padding: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/modules/my-tickets/MyTickets.scss","webpack://./src/modules/my-tickets/MyTickets.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,mBAAmB;ACCrB;;ADCE;EACE,kBAAkB;EAClB,mBAAmB;ACEvB;;ADCE;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;ACEjB","sourcesContent":[".my-tickets {\n  background-color: #F6F6F6;\n  padding-block: 24px;\n\n  &__container {\n    border-radius: 8px;\n    background: #FFFFFF;\n  }\n\n  &__title {\n    color: #323232;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    padding: 24px;\n  }\n}",".my-tickets {\n  background-color: #F6F6F6;\n  padding-block: 24px;\n}\n\n.my-tickets__container {\n  border-radius: 8px;\n  background: #FFFFFF;\n}\n\n.my-tickets__title {\n  color: #323232;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  padding: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
